module.exports = __webpack_public_path__ + "img/sintesis.cb4bfb64.svg";